import React, { useState, useEffect } from 'react';
import { resetImage } from '@/common/reset-image';
import doLog from '@/common/log';
import './index.less';
import MyLazyComponent from '@/common/lazy-load';
import PageStore from '@/stores/page';

// extend.guaranteed
export default function GuaranteedAtmosphere({
  guaranteed,
}: {
  guaranteed: DetailTypes.Guaranteed;
}) {
  const [isShow, setShow] = useState(false);
  useEffect(() => {
    doLog('/sc.details.alibabaguranteed_tag', '', 'EXP');
  }, []);

  if (!guaranteed) return null;
  const { guaranteedIcon, guaranteedBeltList, guaranteedPopUp } = guaranteed;
  const { guaranteedDescription, guaranteedList, tcText } = guaranteedPopUp;

  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;

  if (guaranteedBeltList?.length === 0) return null;
  const GuaranteedDialog = MyLazyComponent(() => import('./dialog'));

  return (
    <>
      <div
        className="detail-guaranteed-layout"
        onClick={() => {
          doLog('/sc.details.alibabaguranteed_tag', '', 'CLK');
          setShow(true);
        }}
      >
        <div className="guaranteed-title">
          <img src={resetImage(guaranteedIcon)} />
          <svg
            className="guaranteed-info-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="2321"
            width="20"
            height="20"
          >
            <path
              d="M512 97.52381c228.912762 0 414.47619 185.563429 414.47619 414.47619s-185.563429 414.47619-414.47619 414.47619S97.52381 740.912762 97.52381 512 283.087238 97.52381 512 97.52381z m0 73.142857C323.486476 170.666667 170.666667 323.486476 170.666667 512s152.81981 341.333333 341.333333 341.333333 341.333333-152.81981 341.333333-341.333333S700.513524 170.666667 512 170.666667z m36.571429 268.190476v292.571428h-73.142858V438.857143h73.142858z m0-121.904762v73.142857h-73.142858v-73.142857h73.142858z"
              fill="#4B1D1F"
              p-id="2322"
            ></path>
          </svg>
        </div>
        <div className="guaranteed-info-list">
          {guaranteedBeltList.map((item) => (
            <>
              <svg
                className="guaranteed-info-icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2168"
                width="16"
                height="16"
              >
                <path
                  d="M512 97.52381c228.912762 0 414.47619 185.563429 414.47619 414.47619s-185.563429 414.47619-414.47619 414.47619S97.52381 740.912762 97.52381 512 283.087238 97.52381 512 97.52381z m0 73.142857C323.486476 170.666667 170.666667 323.486476 170.666667 512s152.81981 341.333333 341.333333 341.333333 341.333333-152.81981 341.333333-341.333333S700.513524 170.666667 512 170.666667z m193.194667 145.188571l52.467809 50.956191-310.662095 319.683047-156.379429-162.230857 52.662858-50.761143 103.936 107.812572 257.974857-265.45981z"
                  fill="#4B1D1F"
                  p-id="2169"
                ></path>
              </svg>
              <span>{item}</span>
            </>
          ))}
        </div>
        <svg
          className="guaranteed-bg-icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="1739"
          width="112"
          height="112"
        >
          <path
            d="M512 0C229.2224 0 0 229.2224 0 512s229.2224 512 512 512 512-229.2224 512-512S794.7776 0 512 0z m0 972.8c-254.4896 0-460.8-206.3104-460.8-460.8S257.5104 51.2 512 51.2s460.8 206.3104 460.8 460.8-206.3104 460.8-460.8 460.8z m-25.6-204.8a25.6 25.6 0 0 1-51.2 0 25.6 25.6 0 1 0-51.2 0 76.8 76.8 0 1 0 153.6 0v-230.4h-51.2v230.4z m51.2-536.2944V204.8a25.6 25.6 0 1 0-51.2 0v26.9056C314.5984 244.8128 179.2 388.0448 179.2 563.2h51.2a76.8 76.8 0 1 1 153.6 0h51.2a76.8 76.8 0 1 1 153.6 0h51.2a76.8 76.8 0 0 1 153.6 0h51.2c0-175.1552-135.3984-318.3872-307.2-331.4944zM716.8 435.2c-42.0608 0-79.0528 20.5824-102.4 51.8912C591.0528 455.7824 554.0608 435.2 512 435.2c-42.0608 0-79.0528 20.5824-102.4 51.8912C386.2528 455.7824 349.2608 435.2 307.2 435.2c-18.1248 0-35.328 3.8656-50.944 10.6752C300.7744 349.0048 398.4128 281.6 512 281.6s211.2256 67.4048 255.744 164.2752A127.104 127.104 0 0 0 716.8 435.2z"
            fill="#4B1D1F"
            p-id="1740"
          ></path>
        </svg>
      </div>
      {isLoaded && (
        <GuaranteedDialog isShow={isShow} setShow={setShow}>
          <div className="guaranteed-dialog">
            <img className="guaranteed-dialog-icon" src={resetImage(guaranteedIcon)} />
            <div className="guaranteed-dialog-description">{guaranteedDescription}</div>
            {guaranteedList.map((item: DetailTypes.GuaranteedList) => (
              <div className="guaranteed-dialog-item">
                <img className="guaranteed-dialog-img" src={resetImage(item.icon)}></img>
                <div>
                  <div className="guaranteed-dialog-title">{item.title}</div>
                  <div className="guaranteed-dialog-info">{item.info}</div>
                </div>
              </div>
            ))}
            <div className="guaranteed-tc-text">{tcText}</div>
          </div>
        </GuaranteedDialog>
      )}
    </>
  );
}
